import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router'; import { AcessoLinksDocumentosComponent } from '../acesso-links-documentos.component';
;

// id = identifica, tp = tipo do documento caso ele seje comunicado
const acessoDocumentosRoutes = [
    { path: 'institucionalAcessoDocumentos', component: AcessoLinksDocumentosComponent },
];

@NgModule({
    imports: [RouterModule.forChild(acessoDocumentosRoutes)],
    exports: [RouterModule]
})
export class AcessoLinksDocumentosRoutingModule {
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/area-restrita/institucional/acesso-links-documentos/router/acesso-links-documentos.router.ts